import React, { useState } from "react";
import Card from "@material-ui/core/Card";
import Button from "../Button";
import CloseIcon from "@material-ui/icons/Close";
import { noselect } from "../../styles/common.css";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { SSNNumberMask, ssnUnmaskedValue } from "../../util/masks";

const useStyles = makeStyles({
  root: {
    width: "600px",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    border: "none",
  },
  cardTitle: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "18px",
    fontWeight: "bold",
    padding: "10px",
    backgroundColor: "#202124",
    color: "white",
    letterSpacing: "1px",
    "& .MuiSvgIcon-root": {
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#585858",
        color: "white",
      },
    },
  },
  optionContainer: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "0px 10px",
    transition: "all 0.2s ease",
  },
  enableButton: {
    transition: "all 0.3s linear",
  },
});

// RerunCreditDialog prompts for a full 9-digit SSN and triggers a credit rerun.
// The SSN lives only in local state and is cleared whenever the dialog closes;
// it is never written to redux or localStorage.
const RerunCreditDialog = ({ handleCloseRerunDialog, details, onRerun }) => {
  const classes = useStyles();
  const [ssnMasked, setSsnMasked] = useState("");
  const ssn = ssnUnmaskedValue(ssnMasked);
  const isValid = ssn.length === 9;

  const close = () => {
    setSsnMasked("");
    handleCloseRerunDialog();
  };

  return (
    <div className={classes.root}>
      <Card className={classes.card} variant="outlined">
        <div className={`${classes.cardTitle} ${noselect}`}>
          <span>Rerun Credit Check</span>
          <CloseIcon onClick={() => close()} />
        </div>
        <Grid container style={{ padding: "10px", paddingTop: "10px" }}>
          <Grid item md={12}>
            <div style={{ paddingBottom: "10px", paddingTop: "10px" }}>
              Enter the full 9-digit SSN to re-run the credit check. The current
              credit report and deposit will be archived and replaced.
            </div>
          </Grid>
          <Grid style={{ paddingTop: "10px" }} item md={12}>
            <TextField
              label="Social Security Number"
              size="small"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              InputProps={{ inputComponent: SSNNumberMask }}
              id="ssn"
              style={{ width: "100%" }}
              onChange={(e) => setSsnMasked(e.target.value)}
              value={ssnMasked}
              error={ssnMasked.length > 0 && !isValid}
              helperText={
                ssnMasked.length > 0 && !isValid
                  ? "SSN must be 9 digits"
                  : ""
              }
            />
          </Grid>
        </Grid>
        <div
          className={classes.optionContainer}
          style={{
            borderTop: "2px solid #ddd",
            paddingBottom: "10px",
          }}
        >
          <Button color="secondary" varian="raised" onClick={() => close()}>
            Close
          </Button>
          <Button
            className={classes.enableButton}
            color="primary"
            varian="raised"
            disabled={!isValid}
            onClick={async () => {
              const enteredSSN = ssn;
              await close();
              await onRerun(details, enteredSSN);
            }}
          >
            Confirm
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default RerunCreditDialog;
